import { useTranslation } from "react-i18next"; // Import translation hook
import { AppContext } from "../contexts/AppContext.jsx";
import { LanguageContext } from "../contexts/LanguageContext.jsx";
import { useContext, useEffect, useRef, useState } from "react";
import { ThemeContext } from "../contexts/ThemeContext.jsx";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../features/categories/categorySlice";
import { useNavigate } from "react-router-dom";

function Navbar_1() {
  const { theme, toggleTheme } = useContext(ThemeContext);
    const { searchKey, setSearchKey, filters, setFilters ,BASE_URL} = useContext(AppContext);
  
  const { language, changeLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();
  const popupRef = useRef(null);
  const { t } = useTranslation("home");
  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { categories } = useSelector(state => state.categories);

  useEffect(() => {
    dispatch(fetchCategories(BASE_URL));
    console.log(categories);
  }, [dispatch]);

  const handleLanguageChange = lang => {
    changeLanguage(lang);
  };

  const handleSearch = e => {
    if (e.key === "Enter" || e.type === "click") {
      navigate("/shop");
    }
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleCategoryFilterChange = (categoryId, e) => {
    e.stopPropagation();
    const category = categories?.find(c => c.id == categoryId);
    if (!category) return;

    setFilters([])
    
    setFilters(prev => {
      const newFilters = { ...prev };
      newFilters[categoryId] = [categoryId, ...(category.children?.map(child => child.id) || [])];
      return newFilters;
    });

    navigate("/shop");

  };

  return (
    <div className='nav_1'>
      <div className='row align-items-center'>
        <div className='col-2 logo' onClick={()=>{navigate("/");}} >
          <img alt='' src='/assets/images/white/logo.svg' width='73' height='63' className='d-inline-block align-top' />
        </div>
        <div className='col-4'>
          <div className='row nav_search'>
            <div className='col-5'>
              <input
                type='text'
                className='w-100 h-100'
                placeholder='Search Product'
                value={searchKey}
                onChange={e => setSearchKey(e.target.value)}
              />
              {/* <input type='text' className='w-100 h-100 ' placeholder='Search Product' /> */}
            </div>
            <div className='col-5 d-flex align-items-center'>
              <span className='nav_search_seprator'></span>
              <button onClick={() => setIsOpen(!isOpen)}>
                <span className='mx-2'>All Categories</span>
                <img src='/assets/images/white/arrow.svg' className={`mx-1 ${isOpen ? "opened" : ""}`} alt='' />
              </button>
            </div>
            <div className='col-2'>
              <button onClick={handleSearch} className='w-100 h-100 submit'>
                Search
              </button>
            </div>
          </div>
        </div>

        <div className='col-6 d-flex align-items-center justify-content-end'>
          <a href='' className='nav_1_item'>
            <img src={`/assets/images/${theme}/theme.svg`} className='nav_item_image' alt='' onClick={toggleTheme} />
          </a>
          <div className='d-flex align-items-center'>
            <button
              className={`btn nav_item_lang ${language === "en" ? "active_lang" : ""}`}
              onClick={() => handleLanguageChange("en")}>
              {" "}
              EN{" "}
            </button>
            <span className='sperator_lang'></span>
            <button
              className={`btn nav_item_lang ${language === "ar" ? "active_lang" : ""}`}
              onClick={() => handleLanguageChange("ar")}>
              {" "}
              Ar{" "}
            </button>
          </div>
          <div className='nav_1_item'>
            <img src={`/assets/images/${theme}/user.svg`} className='nav_item_image' alt='' />
            <span className='nav_item_title'>{t("login")}</span>
          </div>
          <a href='' className='nav_1_item'>
            <img src={`/assets/images/${theme}/wishlist.svg`} className='nav_item_image' alt='' />
            <span className='nav_item_title'> {t("wishlist")}</span>
          </a>
          <a href='' className='nav_1_item'>
            <img src={`/assets/images/${theme}/cart.svg`} className='nav_item_image' alt='' />
            <span className='nav_item_title'> {t("cart")}</span>
          </a>
        </div>
      </div>

      {isOpen && (
        <div className='cates_popup' ref={popupRef}>
          <div className='p-5'>
            <div className='row'>
              {categories.map(cate => (
                <div key={cate.id} className='col-6 popup_cate_container'  onClick={e => handleCategoryFilterChange(cate.id, e)}>
                  <a
                    href='#'
                    className='popup_cate_item'
                    onClick={e => {
                      e.preventDefault();
                      // Handle category click here
                      setIsOpen(false); // Close after selection
                    }}>
                    <img src={cate.icon} className='nav_item_image' alt='' />
                    <p className='popup_cate_item_title'>{language === "ar" ? cate.name_ar : cate.name_en}</p>
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Navbar_1;
